import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qcb86t4azp: FaireBrandEntity = {
  token: "b_qcb86t4azp",
  type: "brand",
  name: "Newport Knits",
  avatarUrl:
    "https://cdn.faire.com/fastly/537a67ffc6bc27e400ed7df02f6d54452d1ac57063b9a8fb92ec44887587e6d5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ff28373ab9b6fbd4c837c4554df719abe7d40fe2894457a4b9293331923bfd96.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/537a67ffc6bc27e400ed7df02f6d54452d1ac57063b9a8fb92ec44887587e6d5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ff28373ab9b6fbd4c837c4554df719abe7d40fe2894457a4b9293331923bfd96.jpeg",
  location: "Newport Beach, CA, USA",
  minimumOrderDollars: 260,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "The idea for Newport Knits was sparked by our personal experience of spending countless hours cheering on our kids at their various sporting events. We noticed a gap in the market for fashionable fan gear. We strive to create pieces that aren’t merely worn but cherished and that fans can wear with pride beyond the bleachers. The concept of “elevated fan gear” was born, bringing together our love for design, community, and the spirit of support.\n\nNewport Knits is committed to empowering women nationwide through custom-designed, upscale fan gear that combines comfort and elegance.  Our mission is to foster a sense of belonging and pride among fans, offering \nbeautiful, sustainably made knit sweaters that allow individuals to express their loyalty in a chic and authentic way.  \n\nWomen are done with the oversized hoodies and mens t-shirts or crop tops.  With Newport Knits, fans can cheer\n On their teams in style with custom designed sweaters that reflect their pride and spirit.  As both moms with kids \nIn college, we have no doubt that everyone will agree that sweaters from Newport Knits  would benefit every\nbookstore across the US.  There is an extreme lack of attractive women’s fan gear in the market. \n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:22.032Z",
    importedBy: "entity-db-cli",
  },
};
